import script from "./MapPicker.vue?vue&type=script&setup=true&lang=js"
export * from "./MapPicker.vue?vue&type=script&setup=true&lang=js"

import "./MapPicker.vue?vue&type=style&index=0&id=ddc8d898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ddc8d898"]])

export default __exports__